module.exports = __webpack_public_path__ + "img/laba_kotor.0494f777.svg";